<hw-page-header [header]="'integration.message-config.header' | translate" class="page-header">
  <div class="content float-right">
    <hw-button display="primary" (click)="save()">{{ 'core.btn.save' | translate }}</hw-button>
  </div>
</hw-page-header>

<nz-content class="page-content">
  <div class="page-content__container container">
    <div *ngIf="documentConfig">
      <hw-table [header]="'integration.message-config.document.header' | translate">
        <nz-table
          [nzFrontPagination]="false"
          [nzShowPagination]="false"
          nzSize="small"
          [nzLoading]="loading"
          [nzData]="documentConfig.options?.attributes">
          <thead>
            <tr>
              <th>
                {{ 'integration.message-config.document.type' | translate }}
              </th>
              <th>
                {{ 'integration.message-config.document.sign-method' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of documentConfig.options.attributes">
              <td>{{ item.type | localizedConceptName : 'document-type' | async }}</td>
              <td>
                <hw-concept-select
                  codesystem="document-sign-method"
                  [(ngModel)]="item.signingMethod"></hw-concept-select>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </hw-table>
    </div>
  </div>
</nz-content>
